<template>
  <v-container fluid>
    <v-layout class="mb-5" align-start justify-left>
      <v-flex xs12 sm12>
        <v-card>
          <v-card-title>
            Tags
          </v-card-title>
          <v-card-text>
            <v-chip class="ma-2" v-for="tag in tags" :key="tag.name">{{tag.name}}</v-chip>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model="showCreateDailog" max-width="600px">
        <template v-slot:activator="{ on }">
        </template>
        <create-tag 
          @created="onTagCreated"
          v-model="showCreateDailog"></create-tag>
      </v-dialog>
      <v-fab-transition>
        <v-btn
          @click="showDailog"
          color="pink"
          dark
          fixed bottom right fab
        ><v-icon>add</v-icon></v-btn>
      </v-fab-transition>
    </v-layout>
  </v-container>
</template>
<script>
import { DataState } from "@/state"
import { Tag } from "@/models/tag"
import CreateTag from "@/components/CreateTag";
export default {
  components: {
    CreateTag: CreateTag
  },
  data() {
    return {
      tags: [],
      showCreateDailog: false,
      state: DataState.newLoading(),
      createState: DataState.newLoading(),
    };
  },

  mounted () {
    this.onLoaded()
  },

  methods: {
    onLoaded () {
      this.state.changeToLoading()
      Tag.list(true).then((response) => {
        this.tags = response
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    showDailog() {
      this.showCreateDailog = true
    },

    onTagCreated(tag) {
      this.tags.push(tag)
      this.showCreateDailog = false
    },
  }
};
</script>
